import axios from "axios";

export const getNewsCount = (siteName) => {
  try {
    const response = axios.get(
      `${window.connectString}/api/sbg-new/categorycounts/` + siteName
    );
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const getNewsItems = (
  mixitSetting,
  articleListPosition,
  dateDirection,
  siteName,
  sitePaths,
  matchedCategory
) => {
  try {
    if (matchedCategory !== undefined) {
      const response = axios.get(
        `${window.connectString}/api/sbg-news?populate[Provider][populate]=*&populate[Image][populate]=1&filters[DisplayInListings]=true&filters[Sites][Site]=` +
          siteName +
          "&filters[Tags][Category]=" +
          matchedCategory.name +
          mixitSetting +
          "&pagination[start]=" +
          (articleListPosition - 1) +
          "&pagination[limit]=200" +
          "&sort=Date:" +
          dateDirection
      );
      return response;
    } else if (sitePaths.includes("News") && siteName === "Sesame.co.uk") {
      const response = axios.get(
        `${window.connectString}/api/sbg-news?populate[Provider][populate]=*&populate[Image][populate]=1&filters[DisplayInListings]=true&filters[Sites][Site]=` +
          siteName +
          "&filters[news_categories][NewsCategory]=blog_Sesame" +
          mixitSetting +
          "&pagination[start]=" +
          (articleListPosition - 1) +
          "&pagination[limit]=200" +
          "&sort=Date:" +
          dateDirection
      );
      return response;
    } else {
      const response = axios.get(
        `${window.connectString}/api/sbg-news?populate[Provider][populate]=*&populate[Image][populate]=1&filters[DisplayInListings]=true&filters[Sites][Site]=` +
          siteName +
          mixitSetting +
          "&pagination[start]=" +
          (articleListPosition - 1) +
          "&pagination[limit]=200" +
          "&sort=Date:" +
          dateDirection
      );
      return response;
    }
  } catch (error) {
    console.log(error);
  }
};
